import useHost from 'containers/host/useHooks';
import { useState } from 'react';
import { getFilePathWithBackendUrl } from 'utils/helpers/common/http-methods';
import { Joinee, PostJoineeDTO } from 'utils/helpers/models/host-dtos/postReviewJoinee.dto';
import { IoIosArrowDown } from "react-icons/io";
import { IoIosArrowUp } from "react-icons/io";
import { ReactComponent as CalandarIcon } from "assets/images/svgs/calendarDark.svg";
import { ReactComponent as ClockIcon } from "assets/images/svgs/clockdark.svg";
import attendTick from 'assets/images/others/host-side-images/QR_tick.png';
import attendCross from 'assets/images/others/host-side-images/QR_cross.png';
import CustomMessageDisplay from 'components/data-not-found/CustomMessageDisplay';
import noParticipantFound from 'assets/images/gifs/PARTICIPANTS-not-found.gif';





export default function AttendingParticipants(props: {
  participants: any[];
  eventId: number;
  workshopSessions: any[];
  eventAttendance: any[];
}) {
  const { participants, eventId, workshopSessions, eventAttendance } = props;
  const [open, setOpen] = useState(false);
  const [openRows, setOpenRows] = useState<number[]>([0]); // Always open first row by default
  console.log(participants, 'participants');


  const { postReviewJoinee } = useHost()
  // Step 1: Get workshop session IDs
  const workshopSessionsIds = workshopSessions.map(p => p.id);
  console.log(workshopSessions, 'workshopSessions');


  // Step 2: Filter eventAttendance for only those with workshopSessionIds
  const filteredAttendance = eventAttendance.filter(item =>
    workshopSessionsIds.includes(item.workShopSessionId)
  );

  console.log(filteredAttendance, 'filteredAttendance');

  // Step 3: Keep only latest entry per workShopSessionId
  const latestAttendancePerSession = {};

  filteredAttendance.forEach(item => {
    const sessionId = item.workShopSessionId;
    const existing = latestAttendancePerSession[sessionId];

    if (!existing || new Date(item.createdAt) < new Date(existing.createdAt)) {
      latestAttendancePerSession[sessionId] = item;
    }
  });

  // Step 4: Convert to array and log
  const latestAttendances = Object.values(latestAttendancePerSession);
  console.log(latestAttendances, 'latestAttendances');

  const attendedSessionIds = filteredAttendance.map(item => item.workShopSessionId);

  const matchedWorkshopSessions = workshopSessions.filter(session =>
    attendedSessionIds.includes(session.id)
  );

  console.log(matchedWorkshopSessions, 'matchedWorkshopSessions');


  // State for checkboxes
  const [respectfulChecked, setRespectfulChecked] = useState<PostJoineeDTO[]>(
    participants && participants.length > 0
      ? participants.map((p) => new PostJoineeDTO({
          joinees: [new Joinee({ userId: p.id, wasRespectfull: false, wasOnTime: false })]
        }))
      : []
  );

  const [onTimeChecked, setOnTimeChecked] = useState<PostJoineeDTO[]>(
    participants && participants.length > 0
      ? participants.map((p) => new PostJoineeDTO({
          joinees: [new Joinee({ userId: p.id, wasRespectfull: false, wasOnTime: false })]
        }))
      : []
  );



  // Select All handlers
  const handleSelectAllRespectful = (checked: boolean) => {
    setRespectfulChecked(participants.map((p, i) => {
      const current = respectfulChecked[i];
      const existingJoinee = current?.joinees?.[0] ?? new Joinee({ userId: p.id });
      return new PostJoineeDTO({
        referralCode: current?.referralCode ?? '',
        joinees: [new Joinee({
          ...existingJoinee,
          wasRespectfull: checked
        })]
      });
    }));
  };

  const handleSelectAllOnTime = (checked: boolean) => {
    setOnTimeChecked(participants.map((p, i) => {
      const current = onTimeChecked[i];
      const existingJoinee = current?.joinees?.[0] ?? new Joinee({ userId: p.id });
      return new PostJoineeDTO({
        referralCode: current?.referralCode ?? '',
        joinees: [new Joinee({
          ...existingJoinee,
          wasOnTime: checked
        })]
      });
    }));
  };


  // Individual checkbox handlers
  const handleRespectfulChange = (idx: number, checked: boolean) => {
    setRespectfulChecked(prev =>
      prev.map((dto, i) =>
        i === idx
          ? new PostJoineeDTO({
            ...dto,
            joinees: [new Joinee({ ...dto.joinees[0], wasRespectfull: checked })],
          })
          : dto
      )
    );
  };

  const handleOnTimeChange = (idx: number, checked: boolean) => {
    setOnTimeChecked(prev =>
      prev.map((dto, i) =>
        i === idx
          ? new PostJoineeDTO({
            ...dto,
            joinees: [new Joinee({ ...dto.joinees[0], wasOnTime: checked })],
          })
          : dto
      )
    );
  };

  const onSubmit = () => {
    const finalPayload = respectfulChecked.map((dto, idx) => {
      const onTime = onTimeChecked[idx]?.joinees[0]?.wasOnTime;
      return new PostJoineeDTO({
        referralCode: "123456",
        joinees: [
          new Joinee({
            ...dto.joinees[0],
            wasOnTime: onTime,
          })
        ]
      });
    });
    postReviewJoinee({ joinees: finalPayload.map(f => f.joinees[0]), referralCode: '123456' }, eventId);

  }

  const handleOpen = () => {
    setOpen(!open);
  };

  const toggleRow = (idx: number) => {
    setOpenRows(prev =>
      prev.includes(idx)
        ? prev.filter(i => i !== idx)
        : [...prev, idx]
    );
  };



  // Show custom message if no participants
  if (!participants || participants.length === 0) {
    return (
      <div className='w-full pt-10 pb-5'>
        <CustomMessageDisplay
          show={true}
          title="No Participants Available"
          slogan="There are no attending participants to review at this time."
          image={noParticipantFound}
          imageAlt="No participants found"
          className="py-12"
          imageClassName="w-[150px] h-[120px]"
          titleClassName="text-2xl font-bold text-blackie"
          sloganClassName="text-gray-500 text-base"
        />
      </div>
    );
  }

  return (
    <div className='w-full pt-4 sm:pt-6 md:pt-10 pb-5 px-2 sm:px-4 md:px-0'>
      <div className='flex items-center justify-end mb-4 sm:mb-6'>
        <button className="bg-yellowText rounded-md text-white px-4 py-2 text-sm sm:text-base w-full sm:w-auto" onClick={onSubmit}>
          Submit
        </button>
      </div>
      {/* Header - Desktop */}
      <div className='hidden md:flex items-center border-b border-gray-200 pb-4 px-2 sm:px-4 md:px-6'>
        <div className='w-1/3 text-base md:text-lg font-medium text-yellowText'>Name</div>
        <div className='w-1/3 flex items-center gap-2'>
          <input
            type='checkbox'
            checked={respectfulChecked.every(dto => dto.joinees[0]?.wasRespectfull) && respectfulChecked.length > 0}
            onChange={e => handleSelectAllRespectful(e.target.checked)}
            className='custom-checkbox'
          />
          <span className='text-base md:text-lg font-semibold text-yellowText'>Select All</span>
        </div>
        <div className='w-1/3 flex items-center gap-2'>
          <input
            type='checkbox'
            checked={onTimeChecked.every(dto => dto.joinees[0]?.wasOnTime) && onTimeChecked.length > 0}
            onChange={e => handleSelectAllOnTime(e.target.checked)}
            className='custom-checkbox'
          />
          <span className='text-base md:text-lg font-semibold text-yellowText'>Select All</span>
        </div>
      </div>
      {/* Header - Mobile Select All */}
      <div className='md:hidden flex flex-col sm:flex-row gap-3 sm:gap-4 border-b border-gray-200 pb-4 px-3 sm:px-4'>
        <div className='flex items-center gap-2'>
          <input
            type='checkbox'
            checked={respectfulChecked.every(dto => dto.joinees[0]?.wasRespectfull) && respectfulChecked.length > 0}
            onChange={e => handleSelectAllRespectful(e.target.checked)}
            className='custom-checkbox'
          />
          <span className='text-sm sm:text-base font-semibold text-yellowText'>Select All - Respectfull</span>
        </div>
        <div className='flex items-center gap-2'>
          <input
            type='checkbox'
            checked={onTimeChecked.every(dto => dto.joinees[0]?.wasOnTime) && onTimeChecked.length > 0}
            onChange={e => handleSelectAllOnTime(e.target.checked)}
            className='custom-checkbox'
          />
          <span className='text-sm sm:text-base font-semibold text-yellowText'>Select All - On-Time</span>
        </div>
      </div>
      {/* Rows */}
      {participants.map((p, idx) => (
        <>
          <div key={p.id || idx} className='flex flex-col md:flex-row items-start md:items-center border-b-2 border-[#DDDDDD] py-4 sm:py-5 md:py-6 px-3 sm:px-4 md:px-6 md:pr-[10px] gap-3 md:gap-0'>
            <div className='w-full md:w-1/3 flex items-center gap-3 sm:gap-4'>
              <img
                src={getFilePathWithBackendUrl(p.profilePicUrl?.fileDownloadUri) || 'https://picsum.photos/200/300'}
                alt={p.firstName || 'Avatar'}
                className='w-10 h-10 sm:w-12 sm:h-12 rounded-full object-cover flex-shrink-0'
              />
              <span className='text-base sm:text-lg md:text-xl font-bold text-[#202224] capitalize truncate'>
                {p.firstName} {p.lastName}
              </span>
            </div>
            <div className='w-full md:w-1/3 flex items-center gap-2'>
              <input
                type='checkbox'
                checked={respectfulChecked[idx]?.joinees[0]?.wasRespectfull || false}
                onChange={e => handleRespectfulChange(idx, e.target.checked)}
                className='custom-checkbox'
              />
              <span className='text-sm sm:text-base md:text-lg font-normal text-[#747688]'>Respectfull</span>
            </div>
            <div className='w-full md:w-1/3 flex items-center gap-2 justify-between md:justify-start'>
              <div className='flex items-center gap-2'>
                <input
                  type='checkbox'
                  checked={onTimeChecked[idx]?.joinees[0]?.wasOnTime || false}
                  onChange={e => handleOnTimeChange(idx, e.target.checked)}
                  className='custom-checkbox'
                />
                <span className='text-sm sm:text-base md:text-lg font-normal text-[#747688]'>On-Time</span>
              </div>
              <div className='flex items-center gap-2 md:ml-auto' onClick={() => toggleRow(idx)}>
                {openRows.includes(idx) ? <IoIosArrowUp cursor={'pointer'} className='text-xl' /> : <IoIosArrowDown cursor={'pointer'} className='text-xl' />}
              </div>
            </div>
          </div>
          <div>
            {openRows.includes(idx) && (
              <div className='bg-[#F9FAFB] px-3 sm:px-4 md:px-6 py-3 sm:py-4'>
                <h3 className='text-base sm:text-lg font-semibold mb-3 sm:mb-4'>Attended Sessions</h3>
                {workshopSessions.length > 0 ? (
                  (() => {
                    // Sort sessions by date and start time
                    const sortedSessions = [...workshopSessions].sort((a, b) => {
                      const dateA = a.startDateTime ? new Date(a.startDateTime).getTime() : 0;
                      const dateB = b.startDateTime ? new Date(b.startDateTime).getTime() : 0;
                      return dateA - dateB;
                    });
                    
                    return sortedSessions.map((session, sessionIdx) => {
                      const isAttended = attendedSessionIds.includes(session.id);
                   
                      return (
                        <div key={session.id} className='text-xs sm:text-sm text-gray-700 mb-3 sm:mb-4 pb-3 sm:pb-4 border-b border-gray-200 last:border-b-0 last:mb-0 last:pb-0'>
                          <div className="flex flex-col sm:flex-row sm:flex-wrap gap-2 sm:gap-3 md:gap-4 text-sm sm:text-base text-lightBlackText items-start sm:items-center">
                            <p className="flex items-center gap-1 flex-shrink-0">
                              <CalandarIcon className='w-4 h-4 sm:w-5 sm:h-5' /> 
                              <span className='break-words'>{session?.startDateWithMonthAndYear}</span>
                            </p>
                            <p className="flex items-center gap-1 flex-shrink-0">
                              <ClockIcon className='w-4 h-4 sm:w-5 sm:h-5' /> 
                              <span className='break-words'>{session?.startTime} to {session?.endTime}</span>
                            </p>
                            <div className='flex-shrink-0'>
                              <img
                                src={isAttended ? attendTick : attendCross}
                                alt={isAttended ? "attendTick" : "attendCross"}
                                className='w-5 h-5 sm:w-[25px] sm:h-[25px]'
                              />
                            </div>
                          </div>
                        </div>
                      );
                    });
                  })()
                ) : (
                  <div className='text-xs sm:text-sm text-gray-500'>No sessions scheduled</div>
                )}


              </div>
            )}
          </div>
        </>
      ))}
    </div>
  );
}
